const SLOT_LABELS: Record<string, Record<string, string>> = {
  överdel: {
    sv: 'Överdel',
    en: 'Top',
    fi: 'Yläosa',
    da: 'Overdel',
    no: 'Overdel',
    de: 'Oberteil',
    fr: 'Haut',
    es: 'Parte superior',
    it: 'Top',
    nl: 'Bovenstuk',
  },
  underdel: {
    sv: 'Underdel',
    en: 'Bottom',
    fi: 'Alaosa',
    da: 'Underdel',
    no: 'Underdel',
    de: 'Unterteil',
    fr: 'Bas',
    es: 'Parte inferior',
    it: 'Fondo',
    nl: 'Onderstuk',
  },
  skor: {
    sv: 'Skor',
    en: 'Shoes',
    fi: 'Kengät',
    da: 'Sko',
    no: 'Sko',
    de: 'Schuhe',
    fr: 'Chaussures',
    es: 'Zapatos',
    it: 'Scarpe',
    nl: 'Schoenen',
  },
  kavaj: {
    sv: 'Kavaj',
    en: 'Blazer',
    fi: 'Bleiseri',
    da: 'Blazer',
    no: 'Blazer',
    de: 'Blazer',
    fr: 'Blazer',
    es: 'Blazer',
    it: 'Blazer',
    nl: 'Blazer',
  },
  ytterplagg: {
    sv: 'Ytterplagg',
    en: 'Outerwear',
    fi: 'Päällysvaate',
    da: 'Overtøj',
    no: 'Ytterplagg',
    de: 'Oberbekleidung',
    fr: 'Manteau',
    es: 'Prenda exterior',
    it: 'Capospalla',
    nl: 'Bovenkleding',
  },
  accessoar: {
    sv: 'Accessoar',
    en: 'Accessory',
    fi: 'Asuste',
    da: 'Accessory',
    no: 'Accessory',
    de: 'Accessoire',
    fr: 'Accessoire',
    es: 'Accesorio',
    it: 'Accessorio',
    nl: 'Accessoire',
  },
  skjorta: {
    sv: 'Skjorta',
    en: 'Shirt',
    fi: 'Kauluspaita',
    da: 'Skjorte',
    no: 'Skjorte',
    de: 'Hemd',
    fr: 'Chemise',
    es: 'Camisa',
    it: 'Camicia',
    nl: 'Overhemd',
  },
  byxa: {
    sv: 'Byxor',
    en: 'Trousers',
    fi: 'Housut',
    da: 'Bukser',
    no: 'Bukser',
    de: 'Hose',
    fr: 'Pantalon',
    es: 'Pantalones',
    it: 'Pantaloni',
    nl: 'Broek',
  },
  troja: {
    sv: 'Tröja',
    en: 'Sweater',
    fi: 'Pusero',
    da: 'Trøje',
    no: 'Genser',
    de: 'Pullover',
    fr: 'Pull',
    es: 'Jersey',
    it: 'Maglione',
    nl: 'Trui',
  },
  jacka: {
    sv: 'Jacka',
    en: 'Jacket',
    fi: 'Takki',
    da: 'Jakke',
    no: 'Jakke',
    de: 'Jacke',
    fr: 'Veste',
    es: 'Chaqueta',
    it: 'Giacca',
    nl: 'Jas',
  },
  fleece: {
    sv: 'Fleece',
    en: 'Fleece',
    fi: 'Fleece',
    da: 'Fleece',
    no: 'Fleece',
    de: 'Fleece',
    fr: 'Polaire',
    es: 'Forro polar',
    it: 'Pile',
    nl: 'Fleece',
  },
  overshirt: {
    sv: 'Overshirt',
    en: 'Overshirt',
    fi: 'Overshirt',
    da: 'Overshirt',
    no: 'Overshirt',
    de: 'Overshirt',
    fr: 'Surchemise',
    es: 'Sobrecamisa',
    it: 'Overshirt',
    nl: 'Overshirt',
  },
  shorts: {
    sv: 'Shorts',
    en: 'Shorts',
    fi: 'Shortsit',
    da: 'Shorts',
    no: 'Shorts',
    de: 'Shorts',
    fr: 'Short',
    es: 'Pantalones cortos',
    it: 'Pantaloncini',
    nl: 'Korte broek',
  },
  't-shirt': {
    sv: 'T-shirt',
    en: 'T-shirt',
    fi: 'T-paita',
    da: 'T-shirt',
    no: 'T-skjorte',
    de: 'T-Shirt',
    fr: 'T-shirt',
    es: 'Camiseta',
    it: 'T-shirt',
    nl: 'T-shirt',
  },
  sandaler: {
    sv: 'Sandaler',
    en: 'Sandals',
    fi: 'Sandaalit',
    da: 'Sandaler',
    no: 'Sandaler',
    de: 'Sandalen',
    fr: 'Sandales',
    es: 'Sandalias',
    it: 'Sandali',
    nl: 'Sandalen',
  },
  nasduk: {
    sv: 'Näsduk',
    en: 'Pocket square',
    fi: 'Taskuliina',
    da: 'Lommetørklæde',
    no: 'Lommetørkle',
    de: 'Einstecktuch',
    fr: 'Pochette',
    es: 'Pañuelo de bolsillo',
    it: 'Pochette',
    nl: 'Pochet',
  },
  vast: {
    sv: 'Väst',
    en: 'Waistcoat',
    fi: 'Liivi',
    da: 'Vest',
    no: 'Vest',
    de: 'Weste',
    fr: 'Gilet',
    es: 'Chaleco',
    it: 'Gilet',
    nl: 'Gilet',
  },
  stickat: {
    sv: 'Stickat',
    en: 'Knitwear',
    fi: 'Neuleet',
    da: 'Strik',
    no: 'Strikk',
    de: 'Strick',
    fr: 'Maille',
    es: 'Punto',
    it: 'Maglieria',
    nl: 'Gebreid',
  },
  pike_tshirt: {
    sv: 'Piké/T-shirt',
    en: 'Polo/T-shirt',
    fi: 'Pikee/T-paita',
    da: 'Polo/T-shirt',
    no: 'Piké/T-skjorte',
    de: 'Polo/T-Shirt',
    fr: 'Polo/T-shirt',
    es: 'Polo/Camiseta',
    it: 'Polo/T-shirt',
    nl: 'Polo/T-shirt',
  },
  skaljacka: {
    sv: 'Skaljacka',
    en: 'Shell jacket',
    fi: 'Kuoritakki',
    da: 'Skaljakke',
    no: 'Skalljakke',
    de: 'Hardshelljacke',
    fr: 'Veste hardshell',
    es: 'Chaqueta técnica',
    it: 'Giacca hardshell',
    nl: 'Hardshell jas',
  },
  funktionstroja: {
    sv: 'Funktionströja',
    en: 'Technical top',
    fi: 'Tekninen paita',
    da: 'Funktionstrøje',
    no: 'Funksjonstrøye',
    de: 'Funktionsshirt',
    fr: 'Haut technique',
    es: 'Camiseta técnica',
    it: 'Maglia tecnica',
    nl: 'Functioneel shirt',
  },
  vandringsskor: {
    sv: 'Vandringsskor',
    en: 'Hiking boots',
    fi: 'Vaelluskengät',
    da: 'Vandrestøvler',
    no: 'Tursko',
    de: 'Wanderschuhe',
    fr: 'Chaussures de randonnée',
    es: 'Botas de senderismo',
    it: 'Scarpe da trekking',
    nl: 'Wandelschoenen',
  },
  outdoor_accessoar: {
    sv: 'Mössa/Handskar',
    en: 'Hat/Gloves',
    fi: 'Pipo/Käsineet',
    da: 'Hue/Handsker',
    no: 'Lue/Hansker',
    de: 'Mütze/Handschuhe',
    fr: 'Bonnet/Gants',
    es: 'Gorro/Guantes',
    it: 'Berretto/Guanti',
    nl: 'Muts/Handschoenen',
  },
  outdoor_byxa: {
    sv: 'Outdoorbyxor',
    en: 'Outdoor trousers',
    fi: 'Ulkoiluhousut',
    da: 'Outdoorbukser',
    no: 'Turbukser',
    de: 'Outdoorhose',
    fr: 'Pantalon outdoor',
    es: 'Pantalones outdoor',
    it: 'Pantaloni outdoor',
    nl: 'Outdoorbroek',
  },
  funktions_tshirt: {
    sv: 'Funktions-T-shirt',
    en: 'Technical T-shirt',
    fi: 'Tekninen T-paita',
    da: 'Funktions-T-shirt',
    no: 'Funksjons-T-skjorte',
    de: 'Funktions-T-Shirt',
    fr: 'T-shirt technique',
    es: 'Camiseta técnica',
    it: 'T-shirt tecnica',
    nl: 'Technisch T-shirt',
  },
  outdoor_shorts: {
    sv: 'Outdoorshorts',
    en: 'Outdoor shorts',
    fi: 'Ulkoilushortsit',
    da: 'Outdoorshorts',
    no: 'Outdoorshorts',
    de: 'Outdoorshorts',
    fr: 'Short outdoor',
    es: 'Shorts outdoor',
    it: 'Pantaloncini outdoor',
    nl: 'Outdoorshorts',
  },
  keps: {
    sv: 'Keps',
    en: 'Cap',
    fi: 'Lippis',
    da: 'Kasket',
    no: 'Caps',
    de: 'Kappe',
    fr: 'Casquette',
    es: 'Gorra',
    it: 'Cappellino',
    nl: 'Pet',
  },
};

const ARTICLE_GROUP_STEMS: Array<{ stem: string; labels: Record<string, string> }> = [
  {
    stem: 'kalsong',
    labels: {
      sv: 'Underkläder',
      en: 'Underwear',
      fi: 'Alusvaatteet',
      da: 'Undertøj',
      no: 'Undertøy',
      de: 'Unterwäsche',
      fr: 'Sous-vêtements',
      es: 'Ropa interior',
      it: 'Intimo',
      nl: 'Ondergoed',
    },
  },
  {
    stem: 'strump',
    labels: {
      sv: 'Strumpor',
      en: 'Socks',
      fi: 'Sukat',
      da: 'Strømper',
      no: 'Sokker',
      de: 'Socken',
      fr: 'Chaussettes',
      es: 'Calcetines',
      it: 'Calze',
      nl: 'Sokken',
    },
  },
  {
    stem: 'halsduk',
    labels: {
      sv: 'Halsduk',
      en: 'Scarf',
      fi: 'Huivi',
      da: 'Halstørklæde',
      no: 'Skjerf',
      de: 'Schal',
      fr: 'Écharpe',
      es: 'Bufanda',
      it: 'Sciarpa',
      nl: 'Sjaal',
    },
  },
  {
    stem: 'slips',
    labels: {
      sv: 'Slips',
      en: 'Tie',
      fi: 'Solmio',
      da: 'Slips',
      no: 'Slips',
      de: 'Krawatte',
      fr: 'Cravate',
      es: 'Corbata',
      it: 'Cravatta',
      nl: 'Stropdas',
    },
  },
  {
    stem: 'bält',
    labels: {
      sv: 'Bälte',
      en: 'Belt',
      fi: 'Vyö',
      da: 'Bælte',
      no: 'Belte',
      de: 'Gürtel',
      fr: 'Ceinture',
      es: 'Cinturón',
      it: 'Cintura',
      nl: 'Riem',
    },
  },
  {
    stem: 'möss',
    labels: {
      sv: 'Mössa',
      en: 'Beanie',
      fi: 'Pipo',
      da: 'Hue',
      no: 'Lue',
      de: 'Mütze',
      fr: 'Bonnet',
      es: 'Gorro',
      it: 'Berretto',
      nl: 'Muts',
    },
  },
  {
    stem: 'handsk',
    labels: {
      sv: 'Handskar',
      en: 'Gloves',
      fi: 'Hanskat',
      da: 'Handsker',
      no: 'Hansker',
      de: 'Handschuhe',
      fr: 'Gants',
      es: 'Guantes',
      it: 'Guanti',
      nl: 'Handschoenen',
    },
  },
  {
    stem: 'vant',
    labels: {
      sv: 'Vantar',
      en: 'Gloves',
      fi: 'Lapaset',
      da: 'Vanter',
      no: 'Votter',
      de: 'Fäustlinge',
      fr: 'Moufles',
      es: 'Manoplas',
      it: 'Muffole',
      nl: 'Wanten',
    },
  },
  {
    stem: 'keps',
    labels: {
      sv: 'Keps',
      en: 'Cap',
      fi: 'Lippis',
      da: 'Kasket',
      no: 'Caps',
      de: 'Cap',
      fr: 'Casquette',
      es: 'Gorra',
      it: 'Cappellino',
      nl: 'Pet',
    },
  },
  {
    stem: 'solglas',
    labels: {
      sv: 'Solglasögon',
      en: 'Sunglasses',
      fi: 'Aurinkolasit',
      da: 'Solbriller',
      no: 'Solbriller',
      de: 'Sonnenbrille',
      fr: 'Lunettes de soleil',
      es: 'Gafas de sol',
      it: 'Occhiali da sole',
      nl: 'Zonnebril',
    },
  },
];

function localizeArticleGroup(name: unknown, lang?: string): string | null {
  const normalized = String(name ?? '')
    .toLowerCase()
    .normalize('NFC');
  if (!normalized) return null;
  for (const entry of ARTICLE_GROUP_STEMS) {
    if (normalized.includes(entry.stem)) return entry.labels[lang ?? ''] ?? entry.labels['sv'];
  }
  return null;
}

export function localizeCategoryLabel(slot: unknown, fallback: unknown, lang?: string): string {
  const fallbackStr = typeof fallback === 'string' && fallback.trim() ? fallback.trim() : '';
  const slotKey = String(slot ?? '').trim();

  if (!lang || lang === 'sv') {
    return fallbackStr || SLOT_LABELS[slotKey]?.sv || capitalize(slotKey) || 'Plagg';
  }

  const map = SLOT_LABELS[slotKey];
  if (map) return map[lang] ?? map['sv'];
  return localizeArticleGroup(fallbackStr, lang) ?? (fallbackStr || capitalize(slotKey) || 'Plagg');
}

function capitalize(value: string): string {
  if (!value) return '';
  const cleaned = value.replace(/[_-]+/g, ' ');
  return cleaned.charAt(0).toUpperCase() + cleaned.slice(1);
}
